import React, {useContext, useEffect, useState} from "react";
import {Button, Highlight, Layout, Wrapper} from "./styles";
import {Form, Input, Modal, Button as AtButton, Space, Typography, Row, Col} from "antd";
import useVerifyMobile from "./useVerfiyMobile";
import VerifyModal from "./VerifyModal";
import {useGameContactQuery} from "../../hook/verify-mobile";
import UserContext from "../../../component/user/context/UserContext";

export interface ActivationProps {
    enabled: boolean;
    gameId: string;
}
function Activation(props: ActivationProps) {
    const {
        enabled,
        gameId
    } = props;

    const [visible, setVisible] = useState<boolean>(false);

    const {
        current
    } = useContext(UserContext);
    const {
        data: isVerified
    } = useGameContactQuery(current?.uid);
    const [verified, setVerified] = useState<boolean>(false);

    const [opened, setOpened ] = useState<boolean>(false);
    function open() {
        setVisible(true)
        setOpened(true)
    }
    useEffect(() => {
        if (enabled && !opened) {
            open();
        }
    }, [enabled, opened]);
    return <>
        {/*<Overlay />*/}
        {enabled ? <Layout>
            <AtButton size={"large"} danger  onClick={() => {
                open();
            }}>
                激活白名单
            </AtButton>
            <Typography.Text type={"danger"} style={{
                marginTop: 14,
            }}>
               加入100%返利白名单
            </Typography.Text>
            {/*<Button onClick={() => {*/}
            {/*    setVisible(true)*/}
            {/*}}>*/}
            {/*    激活白名单*/}
            {/*</Button>*/}

        </Layout> : null}
        <VerifyModal
            open={visible}
            verified={true}
            // verified={isVerified || verified}
            gameId={gameId}
            onCancel={() => {
                setVisible(false)
            }}
            onFinish={() => {
                setVerified(true);
            }}
            destroyOnClose
        />
    </>
}

export default Activation;